
import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { CarrierdeviceService, getCarrierDeviceList, CARRIERDEVICE, DEFAULT_FLOOR } from '../../../service/carrierdevice/carrierdevice.service';
import { LocaService } from 'app/service/loca/loca.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9253',
  templateUrl: 'wa9253.component.html',
  styleUrls: ['wa9253.component.scss']
})
export class Wa9253Component implements OnInit {
  public componentTitle = 'WA9253:搬送什器マスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public carrierdeviceId: number;
  public floorCd: string;
  public carrierdevicetypeCd: FormControl;
  public carrierdeviceTx: FormControl;
  public widthNr: FormControl;
  public depthNr: FormControl;
  public heightNr: FormControl;
  public fillinglimitNr: FormControl;
  public selectedOwnerId: number ;
  public updcounterNr: number;

  private carrierdevice:any = null;

  public locas: any;
  public floors: any; 

  static readonly DEFALUT_SIZENR = 0;
  static readonly DEFAULT_FILLINGLIMITNR = 100;

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private carrierdevicetypeCdCls = '';
  private carrierdeviceTxCls = '';
  private widthNrCls = '';
  private depthNrCls = '';
  private heightNrCls = '';
  private fillinglimitNrCls = ''

  private carrierdevices:{ code: number; name: string; }[];

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private carrierdeviceService: CarrierdeviceService,
    private locaService: LocaService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.carrierdevicetypeCd = new FormControl('', [
      Validators.required]);
    this.carrierdeviceTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.allBlankOnly),
      Validators.maxLength(validation.carrierdeviceTx.maxLength)]);
    this.widthNr = new FormControl(Wa9253Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceWidthNr.maxNr),
      Validators.min(validation.carrierdeviceWidthNr.minNr)]);
    this.depthNr = new FormControl(Wa9253Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceDepthNr.maxNr),
      Validators.min(validation.carrierdeviceDepthNr.minNr)]);
    this.heightNr = new FormControl(Wa9253Component.DEFALUT_SIZENR, [
      Validators.required,
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.carrierdeviceHeightNr.maxNr),
      Validators.min(validation.carrierdeviceHeightNr.minNr)]);
    this.fillinglimitNr = new FormControl(Wa9253Component.DEFAULT_FILLINGLIMITNR, [
      Validators.required,
      Validators.pattern(validation.integer),
      Validators.max(validation.fillinglimitNr.maxNr),
      Validators.min(validation.fillinglimitNr.minNr)]);

      // 搬送什器種類の取得
      this.carrierdevices = getCarrierDeviceList();

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // フロアコードの取得
    this.locaService
    .get()
    .then(_outputJson => {
      this.locas = _outputJson.locas;
    })
    .catch(error => {
      this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.floors = this.getUniqueFloorCd(this.locas, this.ownerId);
    });
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled)
      return;

    let carrierdeviceTx = String(this.carrierdeviceTx.value.trim());
    let fillinglimitNr = this.fillinglimitNr.value / 100;
    // フロアコードがデフォルトの場合には、空文字を設定する
    if (this.floorCd === DEFAULT_FLOOR) {
      this.floorCd = '';
    } else {
      this.floorCd = String(this.floorCd.split('-')[1]);
    }
  
    let errors = false;
    if (this.carrierdevicetypeCd.errors !== null) {
      this.carrierdevicetypeCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.carrierdeviceTx.errors !== null) {
      this.carrierdeviceTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.depthNr.errors !== null) {
      this.depthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.fillinglimitNr.errors !== null) {
      this.fillinglimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.carrierdeviceService
      .put(
        this.carrierdeviceId,
        this.ownerId,
        this.floorCd,
        this.carrierdevicetypeCd.value,
        carrierdeviceTx,
        this.widthNr.value,
        this.depthNr.value,
        this.heightNr.value,
        fillinglimitNr,
        'wa9253',
        this.updcounterNr,
        )
      .then(outputJson => {
        if (outputJson.count === 1) {
          sessionStorage.setItem('SuccessInfoMessage', '修正が完了しました');
        }
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const selectedCarrierdevice: object = JSON.parse(sessionStorage.getItem('rowCase'));
    this.carrierdevice = selectedCarrierdevice;

    this.carrierdeviceId = selectedCarrierdevice['carrierdeviceId'];
    this.ownerId =selectedCarrierdevice['ownerId'];
    this.ownerCd = selectedCarrierdevice['ownerCd'];
    this.ownerTx = selectedCarrierdevice['ownerTx'];
    this.floorCd = selectedCarrierdevice['floorCd'];
    this.carrierdevicetypeCd.setValue(selectedCarrierdevice['carrierdevicetypeCd']);
    this.carrierdeviceTx.setValue(selectedCarrierdevice['carrierdeviceTx']);
    this.updcounterNr = selectedCarrierdevice['updcounterNr'];
    
    if (Number(selectedCarrierdevice['carrierdevicetypeCd']) === CARRIERDEVICE.PALLET.code) {
      this.setDefaultValueForPallet();
    } else {
      this.widthNr.setValue(selectedCarrierdevice['widthNr']);
      this.depthNr.setValue(selectedCarrierdevice['depthNr']);
      this.heightNr.setValue(selectedCarrierdevice['heightNr']);
      this.fillinglimitNr.setValue(selectedCarrierdevice['fillinglimitNr']);
      this.enableItems();
    }

    this.isSubmitButtonEnabled = false;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.carrierdevicetypeCdCls = this.carrierdevicetypeCd.value === this.carrierdevice['carrierdevicetypeCd'] ? 'normal' : (this.carrierdevicetypeCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.carrierdeviceTxCls = this.carrierdeviceTx.value === this.carrierdevice['carrierdeviceTx'] ? '' : (this.carrierdeviceTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    
    if (Number(this.carrierdevicetypeCd.value) === CARRIERDEVICE.PALLET.code) {
      this.widthNrCls = 'disabled';
      this.depthNrCls = 'disabled';
      this.heightNrCls = 'disabled';
      this.fillinglimitNrCls = 'disabled';
    } else {
      this.checkWidthNrCls();
      this.checkDepthNrCls();
      this.checkHeightNrCls();
      this.checkFillinglimitNrCls();
    }

    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.carrierdevicetypeCdCls !== this.STRINGS_ERROR &&
      this.carrierdeviceTxCls !== this.STRINGS_ERROR &&
      this.widthNrCls !== this.STRINGS_ERROR &&
      this.depthNrCls !== this.STRINGS_ERROR &&
      this.heightNrCls !== this.STRINGS_ERROR &&
      this.fillinglimitNrCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.carrierdevicetypeCdCls === this.STRINGS_ACTIVE ||
        this.carrierdeviceTxCls === this.STRINGS_ACTIVE ||
        this.widthNrCls === this.STRINGS_ACTIVE ||
        this.depthNrCls === this.STRINGS_ACTIVE ||
        this.heightNrCls === this.STRINGS_ACTIVE ||
        this.fillinglimitNrCls === this.STRINGS_ACTIVE
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }

  getUniqueFloorCd(locas: any[], ownerId: number): any {
    interface UniqueFloorCd {
      floor: string;
    }

    const uniqueSet = new Set<string>();
    const floors: UniqueFloorCd[] = 
      locas
        .filter((row: any) => { return Number(row.ownerId) === ownerId })
        .reduce((arr: string[], row: any) => {
          const floor: string = row.whCd + '-' + row.floorCd;
          if (!uniqueSet.has(floor)) {
            uniqueSet.add(floor);
            arr.push(floor);
          }
          return arr;
        }, [])
        .sort()

    return floors;
  }

  changeCarrierdeviceType(event: { target: { value: string; }; }) {
    if (Number(event.target.value) === CARRIERDEVICE.PALLET.code) {
      this.setDefaultValueForPallet();
    } else {
      this.enableItems();
    }
  }

  setDefaultValueForPallet() {
    this.widthNr.setValue(Wa9253Component.DEFALUT_SIZENR);
    this.depthNr.setValue(Wa9253Component.DEFALUT_SIZENR);
    this.heightNr.setValue(Wa9253Component.DEFALUT_SIZENR);
    this.fillinglimitNr.setValue(Wa9253Component.DEFAULT_FILLINGLIMITNR);
    this.widthNr.disable();
    this.depthNr.disable();
    this.heightNr.disable();
    this.fillinglimitNr.disable();
  }

  checkWidthNrCls() {
    if (Number(this.carrierdevice['carrierdevicetypeCd']) === CARRIERDEVICE.PALLET.code) {
      this.widthNrCls = Number(this.widthNr.value) === Wa9253Component.DEFALUT_SIZENR ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);  
    } else {
      this.widthNrCls = this.widthNr.value === this.carrierdevice['widthNr'] ? '' : (this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    }
  }

  checkDepthNrCls() {
    if (Number(this.carrierdevice['carrierdevicetypeCd']) === CARRIERDEVICE.PALLET.code) {
      this.depthNrCls = Number(this.depthNr.value) === Wa9253Component.DEFALUT_SIZENR ? '' : (this.depthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);  
    } else {
      this.depthNrCls = this.depthNr.value === this.carrierdevice['depthNr'] ? '' : (this.depthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    }
  }

  checkHeightNrCls() {
    if (Number(this.carrierdevice['carrierdevicetypeCd']) === CARRIERDEVICE.PALLET.code) {
      this.heightNrCls = Number(this.heightNr.value) === Wa9253Component.DEFALUT_SIZENR ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);  
    } else {
      this.heightNrCls = this.heightNr.value === this.carrierdevice['heightNr'] ? '' : (this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    }
  }

  checkFillinglimitNrCls() {
    if (Number(this.carrierdevice['carrierdevicetypeCd']) === CARRIERDEVICE.PALLET.code) {
      this.fillinglimitNrCls = Number(this.fillinglimitNr.value) === Wa9253Component.DEFAULT_FILLINGLIMITNR ? '' : (this.fillinglimitNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);  
    } else {
      this.fillinglimitNrCls = this.fillinglimitNr.value === this.carrierdevice['fillinglimitNr'] ? '' : (this.fillinglimitNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    }
  }

  enableItems() {
    this.widthNr.enable();
    this.depthNr.enable();
    this.heightNr.enable();
    this.fillinglimitNr.enable();
  }
  
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9253/wa9253.component.ts